<template>
  <v-app>

    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      :width="leftDrawerWidth"
      enable-resize-watcher
      fixed
      app
      light
    >
      <v-list subheader>
        <v-subheader>Actions</v-subheader>
        <template v-for="(item, i) in items">
          <router-link :to="{name:item.link}" style="text-decoration: none;">
            <v-list-tile
              :key="i"
              avatar
              @click=""
            >
              <v-list-tile-action>
                <v-icon v-html="item.icon"></v-icon>
              </v-list-tile-action>
              <v-list-tile-content>

                <v-list-tile-title v-text="item.title"></v-list-tile-title>

              </v-list-tile-content>
            </v-list-tile>
          </router-link>
          <v-divider dark></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      fixed
      :clipped-left="clippedLeft"
      :clipped-right="clippedRight"
      app
      color="cyan"
      dark
    >
      <!--<v-btn icon @click.stop="miniVariant = !miniVariant">
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn>-->
      <v-toolbar-title  class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-xs-and-down">{{title}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon v-on:click.stop="showRightDrawer" v-on:showbtn="showRightDrawerBtn" v-show="isRightDrawerShow">
        <v-icon>menu</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <transition>
        <keep-alive>
          <router-view/>
        </keep-alive>
      </transition>
    </v-content>
    <!--<v-navigation-drawer
      temporary
      :right="right"
      v-model="rightDrawer"
      :clipped="clipped"
      fixed
      app
    >
      <v-list>
        <v-list-tile @click="right = !right">
          <v-list-tile-action>
            <v-icon>compare_arrows</v-icon>
          </v-list-tile-action>
          <v-list-tile-title></v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>-->
  </v-app>
</template>

<script>


  import eventBus from './EventBus.js';


  export default {
    data() {
      return {
        clippedLeft: true,
        clippedRight: true,
        clipped: true,
        leftDrawerWidth: '200',
        isRightDrawerShow: false,
        drawer: false,
        fixed: true,
        items: [{
          icon: 'history',
          title: 'replay',
          link: 'replay'
        }, {
          icon: 'room',
          title: 'tracking',
          link: 'tracker'
        }, {
          icon: 'question_answer',
          title: 'plow request',
          link: 'request'
        }],
        miniVariant: false,
        right: true,
        rightDrawer: false,
        title: 'sp.tracker'
      }
    },
    name: 'App',
    methods: {
      showRightDrawerBtn: function () {
        console.log('received')
        this.isRightDrawerShow = true
      },
      showRightDrawer:function () {
        eventBus.$emit('toggle_right_drawer')
      }

    },
    created:function () {
      var self=this
      eventBus.$on('showbtn',function () {
        self.isRightDrawerShow=true
      });
      eventBus.$on('hidebtn',function () {
        self.isRightDrawerShow=false
      });
    }
  }
</script>

<style>
  .leaflet-control-attribution {
    opacity: 0.4;
    filter: alpha(opacity=40);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue